/**
 * useNewVersionCheck — детект нового деплоя на клиенте.
 *
 * Проблема (mobile cache 2026-07-04): браузер держит кэшированный
 * index.html → старые hashed-бандлы после деплоя. Хук раз в 10 минут и на
 * каждый visibilitychange сверяет вшитый на билде __BUILD_ID__ с
 * /build.json (no-store, мимо HTTP-кэша). Расхождение → возвращает true,
 * Layout показывает ненавязчивый баннер «Обновить».
 */
import { useEffect, useState } from "react";

declare const __BUILD_ID__: string;

const CHECK_INTERVAL_MS = 10 * 60 * 1000;

async function fetchServerBuild(): Promise<string | null> {
  try {
    const r = await fetch("/build.json", { cache: "no-store" });
    if (!r.ok) return null;
    const j = (await r.json()) as { build?: string };
    return j.build ?? null;
  } catch {
    // silent: оффлайн или dev-сервер без build.json — проверка не нужна
    return null;
  }
}

export function useNewVersionCheck(): boolean {
  const [stale, setStale] = useState(false);

  useEffect(() => {
    if (typeof __BUILD_ID__ === "undefined") return;
    let cancelled = false;

    const check = async () => {
      const server = await fetchServerBuild();
      if (!cancelled && server && server !== __BUILD_ID__) setStale(true);
    };

    const onVisible = () => {
      if (document.visibilityState === "visible") void check();
    };

    void check();
    const id = window.setInterval(check, CHECK_INTERVAL_MS);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      cancelled = true;
      window.clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return stale;
}
